import configureStore from 'store/configureStore';

export default configureStore();
